import { FieldState, FieldValidator } from 'final-form';
import { t } from 'i18next';
import { EMAIL_REGEX } from 'regexConstants';
import { isNonEmptyString } from 'utils';
import { VALID } from 'validations';

const required = (errorMessage?: string) => (value: any) => {
  const returnMessage = errorMessage || t('required-message');

  if (
    typeof value === 'undefined' ||
    value === null ||
    (typeof value === 'string' && !isNonEmptyString(value))
  ) {
    // undefined or null values are invalid
    return returnMessage;
  }

  return VALID;
};

const emailValidation = (errorMsg?: string) => (value: string) => {
  if (!value) return VALID;
  return value && EMAIL_REGEX.test(value)
    ? VALID
    : errorMsg || t('email-validation-message');
};

const composeValidators =
  (...validators: FieldValidator<any>[]) =>
  (value: any, allValues: object, meta?: FieldState<any>) =>
    validators.reduce(
      (error, validator) => error || validator?.(value, allValues, meta),
      VALID,
    );

const isFieldEqualTo =
  (otherField: string, errorMsg: string) =>
  (value: string, values: Record<string, any>) =>
    value === values[otherField] ? VALID : errorMsg;

export default {
  required,
  emailValidation,
  composeValidators,
  isFieldEqualTo,
};
